<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col class="text-right">
                    <v-icon @click="dialog = true" color="primary">mdi-brush-outline</v-icon>
                </v-col>

            </v-row>
            <!--<v-container>
                <v-row>
                    <v-col md="6" cols="12">-->
                        <!-- Filter by Year -->
                        <!--<v-menu v-model="yearMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field hide-details v-model="selectedYear" outlined clearable dense
                                              :label="$t('Year')"
                                              readonly
                                              v-bind="attrs" @input="selectYear($event)"
                                              v-on="on"></v-text-field>
                            </template>
                            <v-date-picker :max="maxDate"
                                           type="year" @click:year="selectYear($event)"></v-date-picker>
                        </v-menu>

                    </v-col>
                    <v-col md="6" cols="12">-->
                        <!-- Filter by Quarter (using Calendar) -->
                        <!--<v-select hide-details v-model="selectedQuarter" @input="selectQuarter($event)" clearable outlined dense
                                  :items="quarters"
                                  :label="$t('Quarter')"></v-select>
                    </v-col>
                </v-row>
            </v-container>-->
        </v-card-text>

       

        <!-- Chart 2 -->
        <v-card-text style="margin: auto; margin-top: 0px;">
            <table style="width:100%">
                <tr v-for="(item, index) in value.filter(x=>x.value>0)" :key="index" @click="filterQuestionOption(item)">
                    <!--<td style="width:20%"><v-icon left class="mr-1">mdi-arrow-left</v-icon></td>-->
                    <td style="padding-top: 10px; font-size: 21px;"><table style="color: #000;background-color:white;width:100%;height:35px;padding:0px 10px"><tr><td>{{ item.name }}</td></tr></table></td>
                    <td style="width: 80%; padding-top: 10px; font-size: 21px; color: #000;"><div class="chart-bar" :style="{ width: item.value + '%', backgroundColor:chartColor }"><div style="width:50px; color: #000;">{{ item.value }}%</div></div></td>
                </tr>
            </table>
            <!--<div class="chart-item" v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
        <v-row>
            <v-col cols="2">
                <table style="background-color:white;width:100%;height:35px;padding:0px 10px">
                    <tr>
                        <td>{{ item.name }}</td>
                        <td style="width:20%">
                            <v-icon left class="mr-1">mdi-arrow-left</v-icon>
                        </td>
                    </tr>
                </table>
            </v-col>
            <v-col>
                <div class="chart-bar" :style="{ width: item.value + '%', backgroundColor: chartColor }"><div style="width:30px">{{ item.value }}%</div></div>
            </v-col>
        </v-row>
    </div>-->
        </v-card-text>

        

        <!-- Dialog for Color Picker -->
        <v-dialog v-model="dialog" persistent max-width="500px">
            <v-card>
                <div class="card-title">
                    {{ $t('ChangeColor')}}
                </div>
                <v-card-title></v-card-title>
                <v-card-text>
                    <v-color-picker v-model="chartColor" mode="hexa"></v-color-picker>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialog = false" text>{{$t('Close')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },
            quarters: {
                type: Array,
                default: () => [],
            },
            q: undefined
        },
        data() {
            return {
                selectedChart: 'chart1', // Default chart
                chartColor: '#00bcd4', // Default chart color
                dialog: false, // Dialog visibility
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                maxDate: new Date().toISOString().split('T')[0],
            }
        },
        methods: {
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
                this.$emit('selectEducationLevelYear', year)
            },
            selectQuarter(quarter) {
                this.$emit('selectEducationLevelQuarter', quarter)
            },
            filterQuestionOption(item) {
    this.$emit('filterQuestionOption', item, this.q, this.value)
}
        }
    }
</script>

<style scoped>
    .chart-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 8px;
    }

    .chart-bar {
        height: 35px;
        line-height: 35px;
        color: white;
        text-align: right;
        padding-right: 5px;
        min-width: 0px;
    }

    .vertical-bar {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 120px;
        position: relative;
        margin:0 10px;
        width:50px;
    }

    .barcontainer {
        position: absolute;
        bottom: 50px;
        text-align: center;
    }

    .barname {
        position1: absolute;
        bottom1: 0px;
        width: 50px;
        word-wrap: break-word;
        height: 70px;
    }

        .barname span {
            display: block;
            transform: rotate(-70deg);
            width: 70px !important;
            margin-top: 0px;
            margin-right: 10px;
            height: 10px;
        }

    .bar {
        width: 50px;
        height: 100%;
        color: white;
        text-align: center;
    }

    .titlebackground {
        background-image: url('/public/titlebackground.png');
        background-repeat: no-repeat;
        height: 51px;
        background-size: contain;
        width: 100%;
        color: white;
        padding: 0 10px;
        line-height: 51px;
        background-position: right;
    }
</style>
